// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__1k4Oa","title":"header_title__3swg5","logoContainer":"header_logoContainer__38csN","logo":"header_logo__3EMSa"};